import { IApp03Epic, IEntityChildren } from '../types';
import { AppGlobals } from '../AppGlobals';
import { EntityService, IUpdateEntityDatesPayload } from './EntityService';
import { App03Frameworks } from '../types/App03Workflow';
import { App03EpicStatus } from '../types/App03Epic';

export class App03EpicService extends EntityService<IApp03Epic> {
    private apiURL: string;
    protected childrenEntities = [
        'App03EpicObservers($expand=User)',
        'CustomFields($expand=CustomFieldDfn)',
        'Dependencies($expand=DependentEpic)'   // add Epic Dependencies
    ];


    constructor() {
        super(`/App03Epics`);
        const apiURL = process.env.REACT_APP_ZedX_API!;
        this.apiURL = apiURL;
    }

    public readAllForList(frameworkID?: App03Frameworks, workflowID?: number): Promise<IApp03Epic[]> {
        return this.readAll(
            `?$select=ID,Title,EpicStatus,StartDate,TargetEndDate,EpicPriorityID,WorkflowID`
            + `&$expand=EpicOwner($select=Title)`
            //+ `,Dependencies($expand=DependentEpic($select=ID,Title))`
            + `,Dependencies($select=DependentEpicID)`
            + `&$orderby=ID`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID} and FrameworkID eq ${frameworkID}`
            + (workflowID ? ` and WorkflowID eq ${workflowID}` : '')
        );
    }

    public readAllForAddTaskDropdown(workflowID: number): Promise<IApp03Epic[]> {
        return this.readAll(
            `?$select=ID,Title`
            + `&$orderby=ID`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID} and WorkflowID eq ${workflowID}`
        );
    }

    public readAllActiveEpicsForCounters(frameworkId: number): Promise<IApp03Epic[]> {
        return this.readAll(
            `?$select=ID,WorkflowID`
            + `&$orderby=ID`
            + `&$filter=(EpicStatus eq '${App03EpicStatus.NotStarted}' or EpicStatus eq '${App03EpicStatus.InProgress}')`
            + ` and FrameworkID eq ${frameworkId}`
        );
    }



    public async entityChildren(id: number): Promise<IEntityChildren[]> {
        const entityUrl = `${this.entityUrl}(${id})`;
        const tasks = (await this.axiosGet(`${entityUrl}/App03Tasks?$select=ID&$top=10`)).data.value;
        const evidences = (await this.axiosGet(`${entityUrl}/App03EpicEvidences?$select=ID&$top=10`)).data.value;
        return [
            { ChildType: 'Tasks', CanBeAdopted: false, ChildIDs: (await tasks).map((m: { ID: any }) => m.ID) },
            { ChildType: 'Comments and File Attachments', CanBeAdopted: false, ChildIDs: (await evidences).map((w: { ID: any }) => w.ID) }
        ];
    }

    public async updateEntityDates(payload: IUpdateEntityDatesPayload): Promise<void> {
        await this.axiosPost(`${this.apiURL}/UpdateEpicStartEndDates`, payload);
    }
}